import styled from 'styled-components';

const Panel = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1.9rem;
  background: #FFFFFF;
`;

const Lockup = styled.div`
  display: flex;
  align-items: center;
  gap: 1.1rem;
`;

const Wordmark = styled.span`
  font-family: 'Segoe UI', 'Selawik', -apple-system, BlinkMacSystemFont, 'Helvetica Neue', Arial, sans-serif;
  font-size: 3.1rem;
  font-weight: 600;
  letter-spacing: -0.02em;
  line-height: 1;
  color: ${(props) => props.color};

  @media (max-width: 768px) {
    font-size: 2.3rem;
  }
`;

const Rule = styled.div`
  width: 62%;
  height: 1px;
  background: var(--border-color);
`;

const MicrosoftMark = ({ size }) => (
  <svg width={size} height={size} viewBox="0 0 23 23" aria-hidden="true">
    <rect x="0" y="0" width="11" height="11" fill="#F25022" />
    <rect x="12" y="0" width="11" height="11" fill="#7FBA00" />
    <rect x="0" y="12" width="11" height="11" fill="#00A4EF" />
    <rect x="12" y="12" width="11" height="11" fill="#FFB900" />
  </svg>
);

// Official horizontal Xbox lockup (sphere + XBOX wordmark), from Wikimedia Commons File:XBOX_logo_2012.svg.
const XboxLockup = ({ height }) => (
  <svg height={height} width={(height * 692) / 212} viewBox="-2 0 692 212" aria-hidden="true">
    <g fill="#107C10">
      <path d="M688.6,168.9l-47.5-64l43.4-58.1h-16.3l-35.3,47.4l-35.3-47.4 h-16.2l43.3,58.2l-47.4,64h16.3l39.3-53l39.4,53H688.6" />
      <path d="M365,168.9l-47.4-64l43.3-58.1h-16.2l-35.3,47.4l-35.3-47.4 h-16.3l43.4,58.2l-47.5,64h16.3l39.4-53l39.3,53H365" />
      <path d="M421.9,156.1c0,0-30.6,0-36.3,0v-44.4c5.6,0,36.3,0,36.3,0 c13.8,0,30.2,3.7,30.2,21.2C452.1,153.1,433.1,156.1,421.9,156.1z M385.6,59.5c5.6,0,36.3,0,36.3,0c9.8,0,26.3,2.4,26.3,19.4 c0,12.8-9.6,20.5-26.3,20.5c0,0-30.6,0-36.3,0C385.6,99.4,385.6,59.5,385.6,59.5z M455.2,109.5c-2.6-2.2-5.3-3.9-8.1-5.1 c8.9-4.8,14.8-13.9,14.8-24.4c0-7.8-2.9-33.2-40.1-33.2h-50.1v52.7c0,0-16.2,0-16.7,0c-2.2,2.8-7.1,9.5-9,12.2c1.8,0,25.7,0,25.7,0 v57.2h50.1c27.2,0,44.1-13.7,44.1-35.7C466,123.6,462.3,115.4,455.2,109.5" />
      <path d="M531.1,158.7c-26.5,0-45-20.9-45-50.9c0-30,18.5-50.9,45-50.9 c26.4,0,44.8,20.9,44.8,50.9C575.9,137.7,557.5,158.7,531.1,158.7z M531.1,44c-34.8,0-59,26.2-59,63.8c0,37.6,24.2,63.8,59,63.8 c34.6,0,58.8-26.2,58.8-63.8C589.9,70.2,565.7,44,531.1,44" />
      <g transform="matrix(0.23106064,0,0,0.23106064,-1.2020454,3.6254332)">
        <path d="M409.1,885c-69.2-6.6-139.3-31.5-199.6-70.9 c-50.5-33-61.9-46.5-61.9-73.6c0-54.3,59.7-149.5,161.7-257.9c58-61.6,138.7-133.8,147.4-131.9c17,3.8,152.7,136.4,203.5,198.7 C740.6,648.2,777.6,729,758.8,765C744.5,792.4,656,845.9,591,866.4C537.4,883.4,467,890.6,409.1,885z M79.5,684.1 C37.6,619.7,16.4,556.2,6.1,464.5c-3.4-30.3-2.2-47.6,7.7-109.8c12.3-77.5,56.3-167.1,109.3-222.3c22.6-23.5,24.6-24.1,52.1-14.8 c33.4,11.3,69,35.9,124.3,86l32.3,29.2l-17.6,21.7C232.3,355.1,146,497.7,113.5,585.9C95.8,633.8,88.7,682,96.3,702 C101.4,715.5,96.7,710.5,79.5,684.1z M815.5,695c4.1-20.2-1.1-57.4-13.4-94.9C775.6,518.9,686.7,367.7,605.1,265l-25.7-32.3 l27.8-25.6c36.3-33.4,61.5-53.4,88.7-70.3c21.5-13.4,52.1-25.2,65.3-25.2c8.1,0,36.7,29.7,59.8,62.2 c35.8,50.2,62.1,111.2,75.4,174.6c8.6,41,9.3,128.7,1.4,169.5c-6.5,33.5-20.3,77-33.7,106.6c-10.1,22.1-35.1,65-46.1,79 C812.4,710.5,812.4,710.5,815.5,695L815.5,695z M416.5,96.2C378.8,77,320.7,56.5,288.6,50.9c-11.3-1.9-30.4-3-42.7-2.4 c-26.5,1.3-25.3,0,17.2-20.1c35.3-16.7,64.8-26.5,104.8-34.9c45-9.5,129.5-9.6,173.8-0.2c47.8,10.1,104.1,31.1,135.8,50.6l9.4,5.8 l-21.6-1.1c-43-2.2-105.6,15.2-172.9,48c-20.3,9.9-37.9,17.8-39.2,17.5C452,113.9,435.4,105.8,416.5,96.2z" />
      </g>
    </g>
  </svg>
);

const CompanyLogos = () => (
  <Panel role="img" aria-label="Microsoft and Xbox">
    <Lockup>
      <MicrosoftMark size={60} />
      <Wordmark color="#5E5E5E">Microsoft</Wordmark>
    </Lockup>
    <Rule />
    <XboxLockup height={62} />
  </Panel>
);

export default CompanyLogos;
